import JsTypeInspector from "../../serviceLayer/validators/JsTypeInspector.js";
import HtmlTagName from "../../utils/stringLiterals/HtmlTagName.js";


const createUserObjectFromRegistrationForm = function(registrationForm ){
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const userObj = Object.freeze({
        username : registrationForm[0].value,
        email : registrationForm[1].value,     
        password :  (JsTypeInspector.objectIsNullOrEmpty(registrationForm[2])) ? "" : registrationForm[2].value,
        timeZone : timezone
    });

    return userObj;
}


const createPasswordComparer = function(password, confirmPassword){
    const inputObj = Object.freeze({
        input1Name: HtmlTagName.PASSWORD,
        input1Value : password,
        input2Name : HtmlTagName.CONFIRMPASSWORD,
        input2Value : confirmPassword
    });

    return inputObj;
}

const UserCreator = Object.freeze({
    createUserObjectFromRegistrationForm : createUserObjectFromRegistrationForm,
    createPasswordComparer : createPasswordComparer
});

export default UserCreator;